import * as React from 'react'
import { useNavFolderQuery } from '../../hooks/queries/jobnumbers'
import { buildNavFolderUrl } from './folderUrls'

interface NavFolderButtonProps {
  jobnumber: {
    id: number
    job_id: string
  }
}

export default function NavFolderButton({ jobnumber }: NavFolderButtonProps) {
  const { data, isLoading } = useNavFolderQuery(jobnumber.job_id ? jobnumber.id : undefined)

  if (!jobnumber.job_id) return null
  if (isLoading) {
    return (
      <button className="btn btn-outline-secondary messages-download-attachments-button" disabled>
        <i className="fa fa-spinner fa-spin mr-1" />
        NAV Mapper
      </button>
    )
  }
  if (!data?.path_folder) return null

  const url = buildNavFolderUrl(jobnumber.id, data.path_folder)

  return (
    <a className="btn btn-outline-secondary messages-download-attachments-button" href={url} target="_blank" rel="noopener noreferrer">
      <i className="fa fa-icon fa fa-folder-open mr-2" />
      NAV Mapper
    </a>
  )
}
